import { render, staticRenderFns } from "./TabelaResultadosOnusUsuario.vue?vue&type=template&id=6a6992ca&scoped=true&"
import script from "./TabelaResultadosOnusUsuario.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosOnusUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosOnusUsuario.vue?vue&type=style&index=0&id=6a6992ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6992ca",
  null
  
)

export default component.exports